<!-- 账单明细 -->
<template>
    <div class="pay-detail">
        <veui-dialog
            :open="true"
            :footless="true"
            @cancel="confirm"
        >
            <template #title>
                <div class="head-title">
                    <span class="text">{{ title }}</span>
                </div>
            </template>
            <div class="top-wrap">
                <div class="box">
                    <div class="text">打款金额(元)</div>
                    <div class="num">{{ detailInfo.actualMoney }}</div>
                </div>
                <div class="box">
                    <div class="text">订单总额(元)</div>
                    <div class="num">{{ detailInfo.money }}</div>
                </div>
                <div class="box">
                    <div class="text">扣税金额(元)</div>
                    <div class="num">{{ detailInfo.taxMoney }}</div>
                </div>
            </div>
            <div class="table-top">
                <div class="export" @click="downloadOrder">
                    <div class="text">下载打款明细</div>
                    <div class="icon"></div>
                </div>
            </div>
            <div class="table">
                <veui-table
                    ui="m"
                    align="center"
                    :data="payList"
                    role="columnheader"
                    :loading="isTableLoading"
                >
                    <veui-table-column
                        field="date"
                        title="订单时间"
                        width="120"
                    >
                        <template #default="{ date }">
                            {{ date | dateFilter }}
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="type"
                        title="订单类型"
                        width="130"
                    >
                        <template #default="{ type }">
                            {{ type }}咨询
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="oid"
                        title="订单编号"
                        width="240"
                    />
                    <veui-table-column
                        field="price"
                        title="订单金额(元)"
                        width="100"
                    />
                    <veui-table-column
                        field="remarks"
                        title="备注"
                    >
                        <template #default="{ remarks }">
                            {{ remarks || '-' }}
                        </template>
                    </veui-table-column>
                </veui-table>
                <veui-pagination
                    v-if="payCount"
                    :page="page"
                    :total="payCount"
                    :page-size="pageSize"
                    class="pagination"
                    @redirect="pageChange"
                />
            </div>
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @file detail.vue
 * @author dingzhenyue
 * @desc 账单明细
 */
import {Dialog, Table, Column, Button, Pagination} from 'veui';
import dayjs from 'dayjs';
import bendSDK from '@baidu/bend-plugin-sdk';
import {downloadTool} from '@/utils/download';

export default {
    data() {
        return {
            payCount: 0, // 订单数量
            payList: [], // 订单列表
            page: 1,
            pageSize: 10,
            isTableLoading: true // 表格加载中
        };
    },
    props: {
        // 详情信息
        detailInfo: {
            'type': Object,
            'default': () => {}
        }
    },
    components: {
        'veui-dialog': Dialog,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-button': Button,
        'veui-pagination': Pagination
    },
    computed: {
        title() {
            let start = this.detailInfo.startDate;
            let end = this.detailInfo.endDate;
            start = dayjs(start).format('MM.DD');
            end = dayjs(end).format('MM.DD');
            return `${start}-${end} 账单明细`;
        }
    },
    filters: {
        dateFilter(date, type = 'YYYY/MM/DD') {
            if (!date) {
                return '-';
            }
            return dayjs(date).format(type) || '-';
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        confirm() {
            this.$emit('closeDetail');
        },

        /**
         * 获取订单列表
         */

        getList() {
            this.isTableLoading = true;
            let params = {
                startDate: dayjs(this.detailInfo.startDate).format('YYYYMMDD') || '',
                endDate: dayjs(this.detailInfo.endDate).format('YYYYMMDD') || '',
                pn: this.page,
                rn: this.pageSize
            };
            this.$http.get('law:/themis/law/income/getorder', {
                params
            }).then(res => {
                res = this.$normalizeResponseData(res);
                if (!res) {
                    return;
                }
                this.payCount = res?.count || 0;
                this.payList = res?.list || [];
            }).catch(err => {
                this.$normalizeResponseError(err);
            }).finally(() => {
                this.isTableLoading = false;
            });
        },

        /**
         * 翻页时更新数据
         *
         * @param {number} pn 第几页
         */

        pageChange(pn) {
            this.page = pn;
            this.getList();
        },

        /**
         * 账单明细-导出
         */

        downloadOrder() {
            const params = {
                startDate: dayjs(this.detailInfo.startDate).format('YYYYMMDD'),
                endDate: dayjs(this.detailInfo.endDate).format('YYYYMMDD'),
                type: 1, // 1:明细订单(点击打款时的明细) 0:订单记录
                taxMoney: +this.detailInfo.taxMoney,
                money: +this.detailInfo.money,
                actualMoney: +this.detailInfo.actualMoney
            };
            downloadTool(params, 'law:/themis/law/income/exportorder', '');
        }
    }
};
</script>

<style lang='less' scoped>
/deep/.veui-dialog-content {
    width: 840px;
    height: 570px;

    .top-wrap {
        display: flex;
        justify-content: space-between;

        .box {
            height: 66px;
            width: 248px;
            background: #F6F8F9;
            border-radius: 5px;
            display: flex;
            align-items: center;
            padding: 0 24px;

            .num {
                margin-left: 12px;
                font-family: HelveticaNeue-Bold;
                font-size: 18px;
                color: #333333;
                line-height: 18px;
                font-weight: 700;
            }

            .text {
                color: #999999;
                text-align: center;
                line-height: 18px;
            }
        }
    }

    .table-top {
        padding: 24px 0;
        display: flex;
        justify-content: flex-end;

        .export {
            cursor: pointer;
            display: flex;
            align-items: center;
            width: fit-content;

            .text {
                font-size: 16px;
                color: #404EFF;
                line-height: 16px;
            }

            .icon {
                height: 20px;
                width: 20px;
                margin-left: 4px;
                background: url(https://lvlin-base.cdn.bcebos.com/bend/profitCenter/export.png) no-repeat center center / 100%;
            }
        }
    }

    .table {
        .veui-table-no-data {
            padding: 18px 0;
            height: 230px;
        }
    }

    .veui-dialog-content-head {
        padding: 24px 24px 20px;

        .head-title {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #000000;
            font-weight: 500;
            line-height: 28px;
        }
    }
}
.pagination {
    padding-top: 24px;
    float: right;
}
</style>
<style lang='stylus' scoped>
    @import '../../../assets/css/law-table.styl';
</style>

